/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AnswerDTO } from './AnswerDTO';
import {
    AnswerDTOFromJSON,
    AnswerDTOFromJSONTyped,
    AnswerDTOToJSON,
    AnswerDTOToJSONTyped,
} from './AnswerDTO';

/**
 * 
 * @export
 * @interface MeasurementDTO
 */
export interface MeasurementDTO {
    [key: string]: any | any;
    /**
     * 
     * @type {number}
     * @memberof MeasurementDTO
     */
    sessionId?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementDTO
     */
    definitionId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MeasurementDTO
     */
    hasRecording?: boolean;
    /**
     * 
     * @type {Array<AnswerDTO>}
     * @memberof MeasurementDTO
     */
    answers?: Array<AnswerDTO> | null;
}

/**
 * Check if a given object implements the MeasurementDTO interface.
 */
export function instanceOfMeasurementDTO(value: object): value is MeasurementDTO {
    return true;
}

export function MeasurementDTOFromJSON(json: any): MeasurementDTO {
    return MeasurementDTOFromJSONTyped(json, false);
}

export function MeasurementDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeasurementDTO {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'definitionId': json['definitionId'] == null ? undefined : json['definitionId'],
        'hasRecording': json['hasRecording'] == null ? undefined : json['hasRecording'],
        'answers': json['answers'] == null ? undefined : ((json['answers'] as Array<any>).map(AnswerDTOFromJSON)),
    };
}

export function MeasurementDTOToJSON(json: any): MeasurementDTO {
    return MeasurementDTOToJSONTyped(json, false);
}

export function MeasurementDTOToJSONTyped(value?: MeasurementDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'sessionId': value['sessionId'],
        'definitionId': value['definitionId'],
        'hasRecording': value['hasRecording'],
        'answers': value['answers'] == null ? undefined : ((value['answers'] as Array<any>).map(AnswerDTOToJSON)),
    };
}

